import { __decorate } from "tslib";
import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
let PreviewImg = class PreviewImg extends Vue {
    /**
     * 移除图片的下标
     */
    remove(ev, index) {
        ev.stopPropagation();
        console.log(index);
        return index;
    }
    /**
     * 上传图片资源，File类型
     * @param data input事件
     */
    updateFile(data) {
        return (data.target && data.target.files[0]) || undefined;
    }
    /**
     * 触发input
     */
    triggerInput() {
        this.imgInput.click();
    }
    // 图片单击放大
    showImagePreview(imageUrl) {
        const image = new Image();
        image.src = imageUrl;
        image.onload = () => {
            // 创建弹出层
            const previewContainer = document.createElement('div');
            previewContainer.style.position = 'fixed';
            previewContainer.style.top = '0';
            previewContainer.style.bottom = '0';
            previewContainer.style.left = '0';
            previewContainer.style.right = '0';
            previewContainer.style.zIndex = '9999';
            previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
            previewContainer.style.display = 'flex';
            previewContainer.style.justifyContent = 'center';
            previewContainer.style.alignItems = 'center';
            document.body.appendChild(previewContainer);
            // 在弹出层中添加图片
            const previewImage = document.createElement('img');
            previewImage.src = imageUrl;
            previewImage.style.maxWidth = '100%';
            previewImage.style.maxHeight = '100%';
            previewContainer.appendChild(previewImage);
            // 点击弹出层，关闭预览
            previewContainer.addEventListener('click', () => {
                document.body.removeChild(previewContainer);
            });
        };
    }
};
__decorate([
    Prop()
], PreviewImg.prototype, "imgList", void 0);
__decorate([
    Prop()
], PreviewImg.prototype, "readonly", void 0);
__decorate([
    Ref()
], PreviewImg.prototype, "imgInput", void 0);
__decorate([
    Emit()
], PreviewImg.prototype, "remove", null);
__decorate([
    Emit()
], PreviewImg.prototype, "updateFile", null);
PreviewImg = __decorate([
    Component({
        name: 'PreviewImg',
    })
], PreviewImg);
export default PreviewImg;
